import { User } from "@moodys/cre-cpm-client-apis.apis.services.auth"
import { Moment } from "moment"

export type LoanStressReportStatus = "done" | "in_progress" | "error"
type LoanStressReportError = "no_assets" | "no_loans" | "server_error"

export interface LoanStressReport {
  type: "loan_stress_report"
  id: string
  attributes: {
    name?: string
    description?: string
    company_ref_uuid?: string
    error_code: LoanStressReportError
    processing: LoanStressReportStatus
    user_id?: number
    user_email?: string
    forecast_date?: string
    analysis_date?: number
    forecast_scenario?: string
    models?: string[]
    filter_asset_portfolio_id?: string[]
    filter_asset_main_type_of_use?: string[]
    filter_asset_state_id?: string[]
    filter_asset_city_id?: string[]
    filter_asset_district_id?: string[]
    filter_loan_loan_type?: string[]
    created_at: number
  }
  relationships: {
    user: User
    input_documents: [
      {
        type: "documents"
        id: string
      }
    ]
    output_documents: [
      {
        type: "documents"
        id: string
      }
    ]
  }
}

export interface LoanStressReportAttributes {
  analysis_date: Moment
  description: string
  forecast_date: string
  forecast_scenario: string // this one is the Interest Rate Forecast Scenario
  models: LoanStressModel[] // this one is the Real Estate Forecast Scenarios
  name: string
  filter_asset_portfolio_id?: string[]
  filter_asset_main_type_of_use?: string[]
  filter_asset_state_id?: string[]
  filter_asset_city_id?: string[]
  filter_asset_district_id?: string[]
  filter_loan_loan_type?: string[]
}

export interface LoanStressModel {
  id: string
}

export const loanStressReportFields = [
  "name",
  "description",
  "company_ref_uuid",
  "processing",
  "user_id",
  "user_email",
  "analysis_date",
  "forecast_date",
  "forecast_scenario",
  "models",
  "error_code",
  "filter_asset_portfolio_id",
  "filter_asset_main_type_of_use",
  "filter_asset_state_id",
  "filter_asset_city_id",
  "filter_asset_district_id",
  "filter_loan_loan_type",
  "created_at",
]

export interface LoanStressReportDocument {
  attributes: {
    document_type: string
  }
  relationships: {
    company: {
      type: string
      id: string
    }
  }
  type: "loan_stress_report_documents"
}

export interface LoanStressReportDocumentResponse {
  type: "loan_stress_report_documents"
  id: string
  attributes: {
    document_type: string
  }
  relationships: {
    loan_stress_report: {
      type: string
      id: string
    }
    document: {
      type: "documents"
      id: string
    }
  }
}
